export default theme => ({
  tableCellRoot: {
    padding: "4px 8px"
  },
  tableCellColor: {
    color: "#000"
  }
});
